import script from "./MultiTabs.vue?vue&type=script&setup=true&lang=js"
export * from "./MultiTabs.vue?vue&type=script&setup=true&lang=js"

import "./MultiTabs.vue?vue&type=style&index=0&id=b3793cc8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b3793cc8"]])

export default __exports__